export const openExternalUrl = (url) => {
  try {
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } catch (e) {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
};

export const isYouTubeUrl = (url) => /(?:youtube\.com\/watch|youtu\.be\/)/.test(url);

export const getYouTubeId = (url) => {
  const match = url.match(/(?:v=|youtu\.be\/)([^&?/]+)/);
  return match ? match[1] : null;
};